import { isValidElement, ReactNode } from 'react';

import { Icon, IconButton } from '@atom/mui';
import { type IconComponent } from '@atom/mui/icons';
import colors from '@atom/styles/colors';

type MapControlProps = {
  icon: IconComponent | ReactNode;
  active?: boolean;
  tooltip?: string;
  onClick: () => void;
  dataCy?: string;
};

const iconButtonStyle = {
  width: '2.375rem',
  height: '2.375rem',
  padding: '0.4375rem',
};

const MapControl = ({
  icon,
  active = false,
  tooltip,
  onClick,
  dataCy,
}: MapControlProps) => {
  const iconColor = active ? colors.brand.blue : colors.neutral.gray;

  return (
    <IconButton
      data-cy={dataCy}
      style={iconButtonStyle}
      onClick={onClick}
      tooltip={tooltip}
      TooltipProps={{ placement: 'bottom-end' }}
    >
      {isValidElement(icon)
        ? icon
        : icon && <Icon color={iconColor} icon={icon as IconComponent} />}
    </IconButton>
  );
};

export default MapControl;
